/**
 * Graph's id for a URL in /shares/{id}: "u!" + the unpadded base64url of the URL's UTF-8 bytes
 * (Graph docs, "Encoding sharing URLs"). The MVP used Node's Buffer; webpack ships no Buffer here
 * (`buffer: false`), so the bytes come from TextEncoder and go through btoa. IE 11 has no
 * TextEncoder: there unescape(encodeURIComponent()) gives the same bytes, as sharingUrlToken does.
 */
export const shareId = (url: string): string => {
  let binary: string = "";
  if (typeof TextEncoder === "function") {
    const bytes: Uint8Array = new TextEncoder().encode(url);
    for (let i = 0; i < bytes.length; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
  }
  else {
    binary = unescape(encodeURIComponent(url));
  }
  return "u!" + btoa(binary).replace(/=+$/, "").replace(/\//g, "_").replace(/\+/g, "-");
};
